import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

// Access cookies live 30 min — on a 401 refresh the session once (refresh cookie, 7 days) and replay the call
const NO_RETRY = ["/auth/login", "/auth/refresh", "/auth/logout", "/auth/verify-2fa", "/join/"];
let refreshing = null;
api.interceptors.response.use((r) => r, async (error) => {
  const { config, response } = error;
  if (!config || response?.status !== 401 || config._retried || NO_RETRY.some((p) => (config.url || "").includes(p))) throw error;
  config._retried = true;
  try {
    refreshing = refreshing || api.post("/auth/refresh").finally(() => { refreshing = null; });
    await refreshing;
  } catch { throw error; }
  return api(config);
});

export function errMsg(e, fallback = "Something went wrong. Please try again.") {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((d) => (d && typeof d.msg === "string" ? d.msg : JSON.stringify(d))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
